module.exports = __webpack_public_path__ + "img/time-alert-mob.a57e3bdc.png";